module.exports = __webpack_public_path__ + "assets/img/Official.5d49a2e8.png";